export enum NgxMatTimepickerUnits {
    HOUR,
    MINUTE
}
